import { Navigate, useLocation } from 'react-router-dom';

function PrivateRoute({ children }) {
  const location = useLocation();
  const sessionExists = sessionStorage.getItem('loggedIn') === 'true';
  const sessionNotExpired = new Date().getTime() < sessionStorage.getItem('expirationTime');

  if (sessionExists && sessionNotExpired) {
    return children;
  } else {
    return <Navigate to="/login" state={{ from: location }} />;
  }
}

export default PrivateRoute;